import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GeneralService } from 'src/app/Service/general.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-epp',
  templateUrl: './edit-epp.component.html',
  styleUrls: ['./edit-epp.component.scss']
})
export class EditEppComponent implements OnInit {

  breadCrumbItems: Array<{}>;
  isdropdownShow: boolean;
  isLoading: boolean;
  submitted = false;
  EditByUserID: FormGroup;
  rowId:any
  currentUser: any;
  constructor(    private route: ActivatedRoute,
    private router: Router,
    private gs: GeneralService,
    private fb: FormBuilder,
    private datepipe: DatePipe) { 
      let a = this.router.getCurrentNavigation().extras
      if(a){
        if(a.state){
          this.rowId = a.state.Uid
          localStorage.setItem('id',this.rowId)
          console.log("RowId",this.rowId)
        }
      }
      if(localStorage.getItem('id')){
        this.rowId = localStorage.getItem('id')
      }
    }

    Epp = [];
  ActiveArray = [
    {
      name: 'InActive',
      value: 0,
    },
    {
      name: 'Active',
      value: 1,
    },
  ];

  selectedValue = this.ActiveArray[0];
  selectedUser = null;
  ngOnInit() {
    this.currentUser = this.gs.getcurrentUser();
    this.breadCrumbItems = [
      {
        label: 'EPP List',
        path: '/users/view-epp',
      },
      { label: 'Edit EPP', path: '/', active: true },
    ];
    this.EditByUserID = new FormGroup({
      start_date: new FormControl(null, Validators.required),
      end_date: new FormControl(null, Validators.required),
      EPP_In_Days: new FormControl(30, [Validators.min(0),Validators.max(30),Validators.required]),
    });
    this.isLoading=true;
    this.gs
      .getEppByUserId(this.rowId)
      .subscribe((Response: any) => {
        this.isLoading=false;
        this.Epp = Response.data;
        console.log('Response',Response.data);

        this.Epp.map((item) => {
          // console.log(item);

          item.start_date = this.datepipe.transform(
            item.start_date,
            'yyyy-MM-dd'
          );
          item.end_date = this.datepipe.transform(item.end_date, 'yyyy-MM-dd');
          // item.active = item.active = 1 ? 'Active' : 'Inactive';
        });
        this.EditByUserID.patchValue(this.Epp[0]);
        // console.log(this.Epp[0].active);
      },(error) => {                              //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      });
  }
  get f() {
    return this.EditByUserID.controls;
  }
  onSubmit() {
    this.submitted = true;
    // console.log(this.route.snapshot.params.UserID, this.EditByUserID.value);
    if (this.EditByUserID.valid) {
      this.submitted = false;
      Swal.fire({
        title: 'Are you sure, you want to update this for all survey no.?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        this.submitted = false;
        if (result.value) {
          this.isLoading = true;
          this.gs
            .editEPP(
              this.rowId,
              this.EditByUserID.value
            )
            .subscribe((data:any) => {
              this.isLoading = false;
              if (data.status === 200) {
                Swal.fire({
                  title: 'Epp Updated Sucessfully',
                  text: data.message,
                  type: 'success',
                }).then(() => {
                  this.router.navigate(['users/view-epp']);
                });
              } else {
                Swal.fire({
                  title: data.error_code,
                  text: data.message,
                  type: 'error',
                });
              }
            },(error) => {                              //Error callback
              this.isLoading = false;
              Swal.fire({
                title: error.status,
                text: "Internal Server Error",
                type: "error",
              });
              //throw error;   //You can also throw the error to a global error handler
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
        this.submitted = false;
      });
    }
  }
  SetEndDate() {
    var date = new Date(this.EditByUserID.controls.start_date.value);
    this.EditByUserID.controls.end_date.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
  }
  add_years(dt,n) 
  {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
  }
}
